globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.TasksProjects = appCustomerSpace.Modals.TasksProjects || {};

appCustomerSpace.Modals.TasksProjects.TasksProjectForm = (function(superClass) {

  utils.extend(TasksProjectForm, superClass);

  function TasksProjectForm() {
    TasksProjectForm.__super__.constructor.apply(this, arguments);

    this.$tasksList = this.$html.find('.tasks-list');
  }

  $.extend(TasksProjectForm.prototype, {
    init: function() {
      var modal = this;

      appCustomerSpace.LimitlessPlugins.initPlugins(modal.$html);

      modal._initTasksOrder();
      modal._initTasksCheckable();
      modal._initActiveTasks();
      modal._initTasksForms();
      modal._initTasksRemove();
      modal._initAddSpecificTask();
      modal._initAddSuggestedTasks();

      return TasksProjectForm.__super__.init.apply(this, arguments);
    },
    _tasksProjectId: function(){
      return this.$html.data('id');
    },
    _initTasksOrder: function(){
      var modal = this,
          $tasksContainer = modal.$html.find('.tasks-list'),
          options = {
            items: '.task.reorderable',
            helper: 'clone',
            containment: '.tasks-list',
            handle: '.task-order',
            start : function(e, ui) {
              $('body').addClass('cursor-grabbing');
              ui.placeholder.css('visibility', 'visible').css('height', ui.helper[0].scrollHeight + 1);
            },
            stop : function(e, ui) {
              $('body').removeClass('cursor-grabbing');
              modal._refreshTaskOrderPositions();
            }
          }

      $tasksContainer.sortable(options);
    },
    _refreshTaskOrderPositions: function(){
      var modal = this;

      modal.$tasksList.find('.task').each(function(){
        var $task = $(this);
        modal._getTaskFields($task).find('.input-order').val($task.index());
      });
    },
    _initTasksCheckable: function(){
      var modal = this;

      modal.$html.on('click', '.task > .task-check', function(e){
        e.stopPropagation();

        var $task = $(this).closest('.task');

        if(modal._isTaskChecked($task)) {
          modal._uncheckTask($task)
        } else {
          modal._checkTask($task)
        }
      });
    },
    _isTaskChecked: function($task) {
      return $task.hasClass('completed');
    },
    _checkTask: function($task){
      $task.addClass('completed').find('.task-check').attr('data-original-title', 'Définir comme non-terminée').tooltip();
      $('.tooltip').remove();

      this._getTaskFields($task).find('select.input-status').val('completed').trigger('change');
    },
    _uncheckTask: function($task){
      $task.removeClass('completed').find('.task-check').attr('data-original-title', 'Définir comme terminée').tooltip();
      $('.tooltip').remove();

      this._getTaskFields($task).find('select.input-status').val('waiting').trigger('change');
    },
    _initActiveTasks: function(){
      var modal = this;

      modal.$html.on('click', '.task:not(.active)' , function(){
        modal._activeTask($(this));
      });
    },
    _activeTask: function($task) {
      var modal = this,
          $activeTask = modal._getActiveTask();

      $task.addClass('active');

      modal._unactiveTask($activeTask, function(){
        $task.find('.task-fields').appendTo('.task-form');
        modal.$html.find('.no-active-task-text').hide();
        appCustomerSpace.CKEditor.init(modal._getTaskForm());
        modal._getTaskForm().fadeIn('fast', function(){

          modal._getTaskForm().find('.input-title').focus();
        });
      });
    },
    _unactiveTask: function($task, callback) {
      var modal = this;

      if($task.length) {
        $task.removeClass('active');
        modal._getTaskForm().fadeOut('fast', function() {
          modal._getTaskForm().find('.task-fields').appendTo($task);
          if(typeof callback == 'function') callback();
        });
      } else {
        if(typeof callback == 'function') callback();
      }
    },
    _getActiveTask: function(){
      return this.$html.find('.task.active');
    },
    _initTasksForms: function(){
      var modal = this;

      modal.$html.on('input', '.input-title', function(){
        var taskRef = $(this).closest('.task-fields').data('ref');
        modal.$html.find(`.task[data-ref=${taskRef}]`).find('.task-title').html($(this).val());
      });
    },
    _getTaskForm: function(){
      return this.$html.find('.task-form');
    },
    _getTaskFields: function($task){
      return this.$html.find(`.task-fields[data-ref=${$task.data('ref')}]`);
    },
    _initTasksRemove: function(){
      var modal = this;
      modal.$html.on('click', '.task.destroyable .task-remove', function(e){
        e.stopPropagation();

        var $task = $(this).closest('.task');
        modal._removeTask($task);
        $task.addClass('removed');
      });
    },
    _removeTask: function($task) {
      var modal = this;

      $task.addClass('destroyed');

      modal._getTaskFields($task).find('.input-destroy').val(true);

      if(modal._getActiveTask().is($task)) {
        modal._unactiveTask($task, function(){
          modal.$html.find('.no-active-task-text').show();
        });
      }
    },
    _initAddSpecificTask: function(){
      var modal = this;

      modal.$html.find('.btn-add-specific-task').on('click', function(e) {
        e.preventDefault();

        modal._appendTasks(modal._newTask(), function($addedTask) {
          modal._activeTask($addedTask);
        });
      });
    },
    _initAddSuggestedTasks: function(){
      var modal = this;

      modal.$html.on('click', '.btn-add-suggested-tasks', function(){
        $(this).addClass('loading').tooltip('hide');
      });
    },
    _makeRef: function() {
      var ref              = '',
          characters       = '0123456789',
          charactersLength = characters.length;

      for(var i = 0; i < 12; i++) {
        ref += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      return ref;
    },
    _newTask: function($task){
      var modal = this,
          $newTask = $task || modal._$taskTemplate().clone(),
          taskRef = modal._makeRef();

      $newTask.attr('data-ref', taskRef)
              .find('.task-fields').attr('data-ref', taskRef)
              .find("input, textarea, select").each(function(){
                var $input = $(this),
                    name = $input.attr('name'),
                    id = $input.attr('id');

                $input.attr('name', name.replace(/(business_services_abstract_tasks_project\[tasks_attributes]\[).*?(\].*)/, `$1${taskRef}$2`))
                      .attr('id', id.replace(/(business_services_abstract_tasks_project_tasks_attributes_).*?(_.*)/, `$1${taskRef}$2`));
              });

      return $newTask;
    },
    _appendTasks: function($newTasks, callback){
      var modal = this;

      appCustomerSpace.LimitlessPlugins.initPlugins($newTasks);

      $newTasks.appendTo(modal.$tasksList);

      modal.$tasksList.animate({
        scrollTop: modal.$tasksList[0].scrollHeight
      }, function(){ if(typeof callback == 'function') callback($newTasks) });
    },
    _$taskTemplate: function(){
      return $(this.$tasksList.find('template').html().trim());
    },
    _includeTask: function($inputTask){
      var modal = this,
          inputTaskKey = $inputTask.find('.input-key').val(),
          inputTaskIsSpecific = (inputTaskKey == 'specific'),
          inputTaskTitle = $inputTask.find('.input-title').val();

      return modal.$tasksList.find('.task:not(.removed)').filter(function(){
        var $task = $(this);

        if(inputTaskIsSpecific) {
          if(inputTaskTitle == modal._taskTitle($task)) return $task;
        } else {
          if(inputTaskKey == modal._taskKey($task)) return $task;
        }
      }).length;
    },
    _getSpecificTasks: function(){
      var modal = this;

      return modal.$tasksList.find('.task').filter(function(){
        var $task = $(this);

        if(modal._isSpecificTask($task)) return $task;
      });
    },
    _getStructuredTasks: function(){
      var modal = this;

      return modal.$tasksList.find('.task').filter(function(){
        var $task = $(this);

        if(!modal._isSpecificTask($task)) return $task;
      });
    },
    _isSpecificTask: function($task){
      return this._getTaskFields($task).find('.input-key').val() == "specific"
    },
    _taskTitle: function($task){
      return this._getTaskFields($task).find('.input-title').val()
    },
    _taskKey: function($task){
      return this._getTaskFields($task).find('.input-key').val()
    },
    updateView: function(data) {
      var $tasksProject = $(data.partial);
      $(`#tasks-project-${this._tasksProjectId()}`).replaceWith($tasksProject);
      new appCustomerSpace.Modules.TasksProjects($tasksProject);
    }
  });

  return TasksProjectForm;

})(appCustomerSpace.Modal);
